import clsx from 'clsx'
import { type InputHTMLAttributes, forwardRef } from 'react'

export interface SliderProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string
}

export const Slider = forwardRef<HTMLInputElement, SliderProps>(function Slider(
  { label, className, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      type="range"
      aria-label={label}
      className={clsx(
        'h-2 w-full cursor-pointer appearance-none rounded-[var(--radius-sm)] bg-[var(--bg-3)]',
        'outline-none focus-visible:shadow-[var(--focus-ring)]',
        'accent-[var(--accent)]',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        className,
      )}
      {...rest}
    />
  )
})
